import React, { FunctionComponent } from "react";
import { Form, Input } from "antd";
import FormLabel from "./FormLabel";
import styles from "../BiformLayout.module.scss";
import { QuestionComponentProps } from "../helper";
import { buildRules } from "../formUtils";

// SHORT_TEXT — single-line text input.
const ShortText: FunctionComponent<QuestionComponentProps> = ({ question, disabled = false }) => (
  <Form.Item
    name={question.id}
    label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}
    rules={buildRules(question)}
    className={styles.disableTextInput}
  >
    <Input disabled={disabled} placeholder={question.placeholder || "Enter"} />
  </Form.Item>
);

export default ShortText;
